<app-projects
(Close)="close()"
[data]="this.data"></app-projects>